export function createVersionString(version = 1) {
  const versionString = '0000' + version;
  return versionString.length > 5 ? versionString.substring(versionString.length - 5) : versionString;
}

export function createAssetS3Key(assetId: string, version: string | number, aspectRatio: string, fileName: string) {
  const versionString = typeof version === 'number' ? createVersionString(version) : version;
  return `assets/${assetId}/${versionString}/${aspectRatio}/${fileName}`;
}

/**
 * Extracts the asset id from an S3 key (or just returns the assetId if it is).
 *
 * @param key S3 key e.g. assets/64ad58563c74adf013f7851a/00001/aspect-1/main.png or just the assetId e.g. 64ad58563c74adf013f7851a
 * @returns
 */
export function getAssetIdFromS3Key(key: string) {
  const keyParts = key.split('/');
  if (keyParts[0] === 'assets') {
    return keyParts[1];
  }
  return keyParts[0];
}

/**
 * Extracts the file name from an S3 key.
 *
 * @param key S3 key e.g. assets/64ad58563c74adf013f7851a/00001/aspect-1/main.png
 * @returns the file part of the key e.g. main.png
 */
export function getFileFromS3Key(key: string) {
  const keyParts = key.split('/');
  return keyParts[keyParts.length - 1];
}

export function prefixAssetS3Key(key: string) {
  if (key.startsWith('assets/')) {
    return key;
  }
  return `assets/${key}`;
}
